import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "valueFormatter", "highlighted"],
  _excluded2 = ["hovered"];
import { Component } from 'react';
import { HoverProvider } from '../HoverProvider';
import memoizeOne from 'react-utils/memoizeOne';
import { getOptionForValue } from './TimeInput.utils';
import { filterProps } from '../../../utils/filterProps';
import { TypeaheadResultsItem } from '../Typeahead';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrivateTimePickerOption = class PrivateTimePickerOption extends Component {
  constructor(props) {
    super(props);
    this._ref = null;
    this.scrollIntoView = () => {
      const el = this._ref;
      if (el == null) {
        return;
      }
      const {
        offsetHeight,
        offsetParent,
        offsetTop
      } = el;
      offsetParent.scrollTop = offsetTop - (offsetParent.offsetHeight - offsetHeight) / 2;
    };
    this.refCallback = ref => {
      this._ref = ref;
    };
    this._getOption = memoizeOne(getOptionForValue);
    this._hovered = false;
  }
  componentDidMount() {
    if (this.props.highlighted) {
      this.scrollIntoView();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      highlighted
    } = this.props;
    if (!this._hovered && highlighted && !prevProps.highlighted) {
      this.scrollIntoView();
    }
  }
  render() {
    const _this$props = this.props,
      {
        value,
        valueFormatter,
        highlighted
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      domProps,
      callbackProps
    } = filterProps(rest);
    const option = this._getOption(value, valueFormatter);
    return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, this.props, {
      children: hoverProviderProps => {
        const {
            hovered
          } = hoverProviderProps,
          hoverProviderRestProps = _objectWithoutPropertiesLoose(hoverProviderProps, _excluded2);
        this._hovered = Boolean(hovered);
        return /*#__PURE__*/_jsx(TypeaheadResultsItem, Object.assign({}, domProps, callbackProps, hoverProviderRestProps, {
          ref: this.refCallback,
          option: option,
          highlighted: highlighted
        }));
      }
    }));
  }
};